import { Eyebrow, FadeIn } from "@/components/blocks";

const CHAPTERS = [
  {
    n: "01",
    text: "Generic apps hand you a template, a timer and a progress bar — then hope you figure out the rest.",
  },
  {
    n: "02",
    text: "StrengthLeap puts an expert coach on camera with you. Every session. Every rep. In real time.",
  },
  {
    n: "03",
    text: "One goal: eliminate pain, build strength, and prepare you for what your body needs to do next.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="bg-bone px-6 py-28 text-ink sm:px-10 sm:py-40 lg:px-16">
      <div className="mx-auto max-w-[1440px]">
        <FadeIn>
          <Eyebrow tone="ink">The Manifesto</Eyebrow>
        </FadeIn>

        <h2 className="mt-10 font-display text-[11vw] font-black uppercase leading-[0.92] tracking-tight sm:text-[8vw] lg:text-[6vw]">
          <FadeIn delay={0.05}>You don’t need</FadeIn>
          <FadeIn delay={0.15}>
            <span className="text-outline-ink block">another app.</span>
          </FadeIn>
          <FadeIn delay={0.25}>You need a coach.</FadeIn>
        </h2>

        <div className="mt-24 grid gap-px border border-ink/15 bg-ink/15 md:grid-cols-3">
          {CHAPTERS.map((c, i) => (
            <FadeIn key={c.n} delay={i * 0.12} className="bg-bone p-8 sm:p-10">
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember">
                {c.n}
              </p>
              <p className="mt-6 text-lg leading-relaxed text-ink/85 sm:text-xl">{c.text}</p>
            </FadeIn>
          ))}
        </div>

        <FadeIn delay={0.1} className="mt-24">
          <p className="font-display text-[9vw] font-black uppercase leading-none tracking-tight sm:text-[6vw]">
            Live<span className="text-lime">.</span> Private<span className="text-lime">.</span> 1:1
            <span className="text-lime">.</span> <span className="text-ink/35">Anywhere.</span>
          </p>
        </FadeIn>
      </div>
    </section>
  );
}
